import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useExternalHref } from '../useExternalHref';
import { msgs } from './messages';

export const useTermsLinks = () => {
  const intl = useIntl();

  const cookiesPolicyHref = useExternalHref({
    linkType: 'memrise-cookies-policy',
  });

  const privacyPolicyHref = useExternalHref({
    linkType: 'memrise-privacy-policy',
  });

  const termsOfUseHref = useExternalHref({
    linkType: 'memrise-terms-of-use',
  });

  const termsLinks = useMemo(
    () =>
      [
        termsOfUseHref && {
          href: termsOfUseHref,
          text: intl.formatMessage(msgs.termsOfUse),
        },
        privacyPolicyHref && {
          href: privacyPolicyHref,
          text: intl.formatMessage(msgs.privacyPolicy),
        },
        cookiesPolicyHref && {
          href: cookiesPolicyHref,
          text: intl.formatMessage(msgs.cookiesPolicy),
        },
      ].filter(Boolean) as { href: string; text: string }[],
    [cookiesPolicyHref, intl, privacyPolicyHref, termsOfUseHref],
  );

  return termsLinks;
};
